module.exports = __webpack_public_path__ + "img/13.ed118432.png";